import * as pokemon from './Pokemon.tych.json';
import * as temtem from './Temtem.tych.json';

export const Presets = [
    pokemon.default,
    temtem.default
]